import { toNumber } from 'lodash-es';
import { ISearchKeyword, ISearchResult } from 'services/api/conversation.convList';
import { buyerNickMask } from 'services/channels/demo';
import { cntMsgToLocalDbCnt } from './msgLocalDeal';

export const backendSearch2LocalAdapter = (result: ISearchResult) => {
  const {
    targetMsgTime,
    targetMsgType,
    targetMsgId,
    targetMsgContent,
    lastMsgType,
    lastMsgId,
    lastMsgTime,
    platform,
  } = result;
  let cnt;

  if (targetMsgContent.trim() !== '') {
    try {
      const msgContent = JSON.parse(targetMsgContent);
      cnt = cntMsgToLocalDbCnt({
        messageType: targetMsgType,
        textContent: targetMsgType === 'TEXT' ? msgContent : '',
        itemContent: targetMsgType === 'ITEM' ? msgContent : '',
        orderContent: targetMsgType === 'ORDER' ? msgContent : '',
        channel: platform,
      } as Conversation.Message);
    } catch (err) {
      //
    }
  }
  if (!cnt) {
    cnt = targetMsgType || lastMsgType;
  }
  const msgTime = targetMsgTime && targetMsgTime !== '0' ? targetMsgTime : lastMsgTime;
  const msgType = targetMsgType || lastMsgType;
  const msgId = targetMsgId && targetMsgId !== '0' ? targetMsgId : lastMsgId;
  return {
    ...result,
    id: toNumber(result.conversationId),
    buyerName: buyerNickMask(result.buyerNick),
    shopId: result.storeId,
    msgTime,
    msgType,
    msgId,
    cnt,
    convId: result.conversationId,
  };
};

export const localTypeMapBackend: Record<string, ISearchKeyword['type']> = {
  buyer: 'buyer',
  product: 'item',
  order: 'order',
  track: 'track',
  text: 'msg',
};

/**
 * 会话服务->订单服务 externalBuyerId 转换
 */
export const conv2TradeExternalBuyerId = (
  platform: General.CaselessPlatform,
  externalBuyerId: string,
) => {
  if (platform === 'MERCADO' && externalBuyerId.includes('_')) {
    return externalBuyerId.split('_')?.[0];
  }
  return externalBuyerId;
};

/**
 * 获取会话服务正确的 externalBuyerId
 * Mercado: [externalBuyerId]_[orderId]
 */
export const getPlatformExternalBuyerId = (
  platform: General.PlatformCaseless,
  externalBuyerId: Conversation.Conversation['externalBuyerId'],
  orderId?: string,
) => {
  if (platform === 'MERCADO' && orderId) {
    return `${externalBuyerId}_${orderId}`;
  }
  return externalBuyerId;
};
